<script setup lang="ts">
import {useStore} from '../store';
import {Video} from '../types';

const props = defineProps<{
    video: Video
}>();

const store = useStore();
</script>

<template>
    <figure class="video-item">
        <a
            href="#"
            class="video-item-thumb"
            :style="{'background-image': `url(${video.thumbnail})`}"
            @click.prevent="store.setPlayVideo(video)"
        />
        <figcaption class="video-item-title">{{ video.title }}</figcaption>
    </figure>
</template>
